import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, subtitle, children, className }) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="ibexiq-modal-overlay" />
        <Dialog.Content className={`ibexiq-modal-content ${className ?? ''}`}>
          <div className="ibexiq-modal-header">
            <div>
              <Dialog.Title className="ibexiq-modal-title">{title}</Dialog.Title>
              {subtitle && <p className="ibexiq-modal-subtitle">{subtitle}</p>}
            </div>
            <Dialog.Close asChild>
              <button className="ibexiq-modal-close" aria-label="Close">
                ×
              </button>
            </Dialog.Close>
          </div>
          <div className="ibexiq-modal-body">{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default Modal;
